import { createSelector } from "reselect";

import { welcomeSelectors } from "../../modules/welcome";

const getSamplesForRightPanel = createSelector(
  // Inputs
  welcomeSelectors.getExampleFiles,
  // Calculation
  exampleFiles => {
    return exampleFiles
      .map(f => {
        let icon = "book";
        if (f.name === "Feature Overview") {
          icon = "lightbulb";
        }
        if (f.name === "App Development Plan") {
          icon = "planDocument";
        }
        if (f.name === "Murder on the Orient Express") {
          icon = "train";
        }
        if (f.name === "Wuthering Heights") {
          icon = "manor";
        }
        return {
          name: f.name,
          fullPath: f.fullPath,
          icon: icon
        };
      })
      .toArray();
  }
);

export default {
  getSamplesForRightPanel
};
